import { MasterHelper } from '../../utilities';
import { LibraryType } from './../../enums/regulator/regulator-status';

export class LibraryDataModel {
  libraryId: number;
  libraryName: string;
  fromDate: string | null;
  toDate: string | null;
  regulationIds: Array<number>;
  libraryType: LibraryType;
  filterJson: string;
  isRulebook: boolean;
  rulebooks: string[];
  isHide: boolean;
  isGlobal: boolean;
  parentId: number;

  constructor() {
    this.libraryId = 0;
    this.libraryName = '';
    this.fromDate = MasterHelper.getDateStr(30);
    this.toDate = MasterHelper.getDateStr(0);
    this.regulationIds = [];
    this.libraryType = LibraryType.Static;
    this.filterJson = '';
    this.isRulebook = false;
    this.rulebooks = [];
    this.isHide = false;
    this.isGlobal = false;
    this.parentId = 0;
  }
}
